import { render } from "./ThankYou.vue?vue&type=template&id=3004ebdb"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=3004ebdb&lang=css"
import "./ThankYou.vue?vue&type=style&index=1&id=3004ebdb&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__